import {DOCTOR_SALES_RCPA_ACTIVITY} from '@app/navigations/RoutePathConstant';
import {authLoader} from '@app/navigations/loader';
import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';

const DoctorSalesRCPAReport = lazy(() =>
  import('../../../screens/DoctorSalesRcpaReport')
    .then(module => ({default: module.DoctorSalesRcpaReport})));
const DoctorSalesRcpaReportNavigation = [
  {
    path: DOCTOR_SALES_RCPA_ACTIVITY,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <DoctorSalesRCPAReport />
      </Suspense>
    ),
  },
];
export default DoctorSalesRcpaReportNavigation;
